import "../../style/mobile/calendar/MBigCalendar.scss";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useEffect, useState } from "react";
import moment from "jalali-moment";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../redux";
// moment(item.updatedAt).format("YYYY/M/D")

let _m = moment();
moment.locale("fa");
let _month = Number(_m.format("M"));
let _year = _m.jYear();
let isCurrentMonh = 1;

const MBigCalendar = () => {
  console.log("_month is:" + _month);
  //settig---------------------------------------
  moment.locale("fa");
  let m = moment();
  let month = Number(m.format("M"));
  let year = m.jYear();
  // let day_1 = moment(`${year}/${month}/1`, 'jYYYY/jM/jD').jDay();
  // console.log("روز اول ماه:"+day_1);
  let day_last = moment(`${year}/${month}/30`, "jYYYY/jM/jD").jDay();
  console.log(day_last);
  // let day = m.jDay();
  let date = m.format("DD");

  //---------------------------------------------------
  const [examDateList] = useState([
    {
      id: 1,
      name: "فلسفه غرب",
      date: "2021-10-11T12:00:00.180Z",
    },
    {
      id: 2,
      name: "هنر معاصر",
      date: "2021-10-11T18:00:00.180Z",
    },
    {
      id: 3,
      name: "تئوری تصمیم‌گیری",
      date: "2021-10-13T11:00:00.180Z",
    },
    {
      id: 4,
      name: "تفکر انتقادی",
      date: "2021-10-09T08:00:00.180Z",
    },
  ]);
  moment.locale("en");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  let classifierExamDateList = [];
  for (let r = 0; r < 31; r++) {
    let z = [];
    for (let l = 0; l < examDateList.length; l++) {
      console.log()
      if (Number(moment(examDateList[l].date).format("jD")) === r + 1) {
        let dd = new Date(examDateList[l].date);
        z.push({
          id: r + l,
          name: examDateList[l].name,
          time: `${dd.getHours()}:${dd.getMinutes()}`,
        });
      }
    }
    classifierExamDateList.push(z);
  }
  console.log(classifierExamDateList);

  //--------------------------------------------------------

  const CreateCalendar = (Year, Month) => {
    moment.locale("fa");
    let day_1 = moment(`${Year}/${Month}/1`, "jYYYY/jM/jD").jDay();
    let day_counter = 0;
    let main_list = [];
    for (let i = 0; i < 42; i++) {
      if (i < day_1) {
        main_list.push({
          id: i + 1,
          day: "",
          isActive: false,
          exam: [],
        });
      } else {
        if (Month > 0 && Month < 7) {
          if (day_counter < 31) {
            day_counter++;
            if (Number(isCurrentMonh) === 1 && day_counter === Number(date)) {
              main_list.push({
                id: i + 1,
                day: day_counter,
                isActive: true,
                exam: classifierExamDateList[day_counter - 1],
              });
            } else {
              main_list.push({
                id: i + 1,
                day: day_counter,
                isActive: false,
                exam: classifierExamDateList[day_counter - 1],
              });
            }
          } else {
            main_list.push({
              id: i + 1,
              day: "",
              isActive: false,
              exam: [],
            });
          }
        } else if (Month > 6 && Month < 12) {
          if (day_counter < 30) {
            day_counter++;
            if (isCurrentMonh === 1 && day_counter === Number(date)) {
              main_list.push({
                id: i + 1,
                day: day_counter,
                isActive: true,
                exam: classifierExamDateList[day_counter - 1],
              });
            } else {
              main_list.push({
                id: i + 1,
                day: day_counter,
                isActive: false,
                exam: classifierExamDateList[day_counter - 1],
              });
            }
          } else {
            main_list.push({
              id: i + 1,
              day: "",
              isActive: false,
              exam: [],
            });
          }
        } else if (Month === 12) {
          if (Number.isNaN(moment(`${Year}/12/30`, "jYYYY/jM/jD").jDay())) {
            if (day_counter < 29) {
              day_counter++;
              if (isCurrentMonh === 1 && day_counter === Number(date)) {
                main_list.push({
                  id: i + 1,
                  day: day_counter,
                  isActive: true,
                  exam: classifierExamDateList[day_counter - 1],
                });
              } else {
                main_list.push({
                  id: i + 1,
                  day: day_counter,
                  isActive: false,
                  exam: classifierExamDateList[day_counter - 1],
                });
              }
            } else {
              main_list.push({
                id: i + 1,
                day: "",
                isActive: false,
                exam: [],
              });
            }
          } else {
            if (day_counter < 30) {
              day_counter++;
              if (isCurrentMonh === 1 && day_counter === Number(date)) {
                main_list.push({
                  id: i + 1,
                  day: day_counter,
                  isActive: true,
                  exam: classifierExamDateList[day_counter - 1],
                });
              } else {
                main_list.push({
                  id: i + 1,
                  day: day_counter,
                  isActive: false,
                  exam: classifierExamDateList[day_counter - 1],
                });
              }
            } else {
              main_list.push({
                id: i + 1,
                day: "",
                isActive: false,
                exam: [],
              });
            }
          }
        }
      }
    }
    return main_list;
  };

  let monthList = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  // let C = CreateCalendar(year,month);
  // for(let i=0;i<C.length;i++){
  //   if(C[i].day===date){
  //     C[i].isActive=true;
  //   }
  // }
  // console.log(C);

  // const [g] = useState(0);
  const [dayList, setDayList] = useState(CreateCalendar(year, month));
  const [MONTH, setMONTH] = useState(month);
  const [YEAR, setYEAR] = useState(year);

  const nextMonth = () => {
    isCurrentMonh++;
    if (MONTH !== 12) {
      setMONTH(MONTH + 1);
      _month++;
    } else {
      setMONTH(1);
      setYEAR(YEAR + 1);
      _month = 1;
      _year++;
    }
    setDayList(CreateCalendar(_year, _month));
    let dayBox = document.querySelectorAll(".MBigCalendar-body-item");
    for (let u = 0; u < dayBox.length; u++) {
      // dayBox[u].style.borderColor="#E0E0E0";
      dayBox[u].style.backgroundColor = "#FFF";
    }
  };
  const previousMonth = () => {
    isCurrentMonh--;
    if (MONTH !== 1) {
      setMONTH(MONTH - 1);
      _month--;
    } else {
      setMONTH(12);
      setYEAR(YEAR - 1);
      _month = 12;
      _year--;
    }
    setDayList(CreateCalendar(_year, _month));
    let dayBox = document.querySelectorAll(".MBigCalendar-body-item");
    for (let u = 0; u < dayBox.length; u++) {
      // dayBox[u].style.borderColor="#E0E0E0";
      dayBox[u].style.backgroundColor = "#FFF";
    }
  };

  const dispatch = useDispatch();
  const { selectDay, showEvent } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    showEvent(classifierExamDateList[date - 1]);
  }, []);

  //-----selectDay---------------------------------
  const CselectDay = (day, index, exam) => {
    if (day) {
      console.log("---" + day, MONTH, YEAR);
      console.log(exam);
      selectDay(YEAR, MONTH, day);
      let dayBox = document.querySelectorAll(".MBigCalendar-body-item");
      for (let u = 0; u < dayBox.length; u++) {
        // dayBox[u].style.borderColor="#E0E0E0";
        dayBox[u].style.backgroundColor = "#FFF";
      }
      // dayBox[index].style.borderColor="#132F52";
      dayBox[index].style.backgroundColor = "#E0E0E0";
      showEvent(exam);
    }
  };

  return (
    <div className="MBigCalendar">
      <div className="MBigCalendar-title-box">
        <div className="MBigCalendar-title-box-year-month">
          <div className="MBigCalendar-title-box-year-month-arrow">
            <IoIosArrowBack
              className={"MBigCalendar-title-box-year-month-arrow-icon"}
              onClick={nextMonth}
            />
            <IoIosArrowForward
              className={"MBigCalendar-title-box-year-month-arrow-icon"}
              onClick={previousMonth}
            />
          </div>
          <div className="MBigCalendar-title-box-year-month-text">
            {monthList[MONTH - 1]}،{YEAR}
          </div>
        </div>
        <div className="MBigCalendar-title-box-guide">
          <div className="MBigCalendar-title-box-guide-text">تقویم آزمون‌ها</div>
        </div>
      </div>
      <div className="MBigCalendar-weekday-row">
        <div className="MBigCalendar-weekday-row-item">شنبه</div>
        <div className="MBigCalendar-weekday-row-item">یکشنبه</div>
        <div className="MBigCalendar-weekday-row-item">دوشنبه</div>
        <div className="MBigCalendar-weekday-row-item">سه‌شنبه</div>
        <div className="MBigCalendar-weekday-row-item">چهارشنبه</div>
        <div className="MBigCalendar-weekday-row-item">پنج‌شنبه</div>
        <div className="MBigCalendar-weekday-row-item">جمعه</div>
      </div>
      <div className="MBigCalendar-body">
        {dayList.map((item, index) => (
          <div
            key={item.id}
            className="MBigCalendar-body-item"
            onClick={() => CselectDay(item.day, index, item.exam)}
          >
            <div
              style={
                item.isActive ? { background: "#132F52", color: "white" } : null
              }
              className="MBigCalendar-body-item-date"
            >
              {item.day}
            </div>
            {item.exam.length > 0 && (
              <div className="MBigCalendar-body-item-line"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MBigCalendar;